import { CountriesQueryFilter } from 'api/countries-list';
import { autoinject, BindingEngine, customElement } from 'aurelia-framework';
import { ModelBase } from 'support/base_classes/model-base';
import { EnumsService } from 'services/enums-service';
import { KeywordsService } from 'services/keywords-service';

@autoinject
@customElement('countries-filter')
export class CountriesFilterCustomElement extends ModelBase<CountriesQueryFilter> {
  constructor(bindingEngine: BindingEngine, public enumService: EnumsService, public keywordsService: KeywordsService) {
    super(bindingEngine);
  }

  archiveOptions = [
    { value: false, name: 'Hide archived items' },
    { value: true, name: 'Show archived items' }
  ];
}
